import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SpinnerSize from 'src/enums/spinnerSize';
import Spinner from 'src/globalComponents/spinner';
import { useApi } from 'src/hooks/useApi.js';
import { toastSuccess } from 'src/Toaster/Toast.js';
import { useQuotationsCount } from 'src/contexts/QuotationsCountContext';

const SignerCompleted: React.FC = () => {
	const api = useApi();
	const navigate = useNavigate();
	const { processId, signerId } = useParams();
	const { refreshCounts } = useQuotationsCount();

	useEffect(() => {
		if (processId && signerId) {
			(async () => {
				const response = await api.esign.markSignerAsCompleted(
					processId,
					signerId
				);

				if (response.nextSigner) {
					navigate(
						`/signInPerson/${processId}/${response.nextSigner.signerId}`
					);
				} else {
					await refreshCounts();
					toastSuccess({ description: 'Proposal signed successfuly' });
					navigate('/quotations');
				}
			})();
		}
	}, [processId, signerId, refreshCounts]);

	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<Spinner size={SpinnerSize.LARGE} />
		</Box>
	);
};

export default SignerCompleted;
